import {Component} from "@angular/core";
import {TerminalSearchModel} from "../terminal-search.model";
import {TerminalEntityModel} from "../terminal-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-terminal-search-page",
    templateUrl: "./terminal-search-page.component.html",
    providers: [provideSearchModel(TerminalSearchModel), provideEntityModel(TerminalEntityModel)]
})
export class TerminalSearchPageComponent extends AbstractSearchPage {

    constructor() {
        super();
    }
}
